import { Preferences } from '@capacitor/preferences'
import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router'
import useBankAuth from '../auth/components/authenticateWithTeliaToken'

const Register = () => {
	const history = useHistory()
	const location = useLocation()
	const bankAuthMutation = useBankAuth()

	useEffect(() => {
		const params = new URLSearchParams(location.search)
		const code = params.get('code')
		const error = params.get('error')

		if (error) {
			console.error('Bank auth error:', error)
			history.push('/')
		}

		if (code) {
			bankAuthMutation
				.mutateAsync({ code })
				.then(async () => {
					const { value } = await Preferences.get({ key: 'postAuthRoute' })
					if (value) {
						await Preferences.remove({ key: 'postAuthRoute' })
						history.push(JSON.parse(value) as string)
					} else {
						history.push('/overview')
					}
				})
				.catch(err => {
					console.error('Failed to complete bank auth:', err)
					history.push('/')
				})
		} else {
			console.warn('No auth code found in URL')
			history.push('/')
		}
	}, [])
	return null
}
export default Register
